<template>
  <slot />
  <PromptModal
    :open="open"
    :variant="variant"
    :message="messageString"
    @update:open="close"
    @resolve="resolve"
  />
</template>

<script lang="ts" setup>
import { provide, ref } from 'vue';
import { confirmPromptKey, deletePromptKey, type PromptVariant } from './injects.js';
import PromptModal from './PromptModal.vue';

const open = ref(false);
const resolveFunction = ref<(value: boolean) => void>();
const variant = ref<PromptVariant | undefined>(undefined);
const messageString = ref<string | undefined>(undefined);

const close = () => {
  open.value = false;
  resolveFunction.value?.(false);
  resolveFunction.value = undefined;
  variant.value = undefined;
};

const resolve = () => {
  open.value = false;
  resolveFunction.value?.(true);
  resolveFunction.value = undefined;
  variant.value = undefined;
  messageString.value = undefined;
};

provide(deletePromptKey, (message?: string) => {
  variant.value = 'delete';
  open.value = true;
  messageString.value = message;
  return new Promise<boolean>((resolver) => {
    resolveFunction.value = resolver;
  });
});

provide(confirmPromptKey, (message: string) => {
  variant.value = 'confirm';
  open.value = true;
  messageString.value = message;
  return new Promise<boolean>((resolver) => {
    resolveFunction.value = resolver;
  });
});
</script>

<style lang="scss" scoped>
</style>
